export const environment = {
  production: true,
  url: 'https://api.taqe.com.br/v2',
  api_gateway: 'https://api-gateway.taqe.com.br',
  landinpage: 'https://vagas.taqe.com.br',
  web_link: 'https://gerenciador.taqe.com.br',
  manager_type: 'taqe',
  hotjar_id: '1578727',
  url_redirect: {
    web_web_v2: 'https://gerenciador.taqe.com.br',
    web_web_v2_lite: 'https://vitrine.taqe.com.br',
  },
  talent_base: false,
  microfrontend: {
    test_module: 'https://mfe-modulo-test.taqe.com.br/main.js'
  },
  pwa_url: 'https://app.taqe.com.br',
  ip_url: 'https://app-ip.taqe.com.br',
  mock_vacancy_step_id: '5a1109341f8773001',
  MAPS_API_KEY: 'AIzaSyB2tFwq_Y3UeajuABH-4fL3KXoQY-8xgXQ',
  secureCookie: true,
  timeToLogoutInSeconds: 3600,
  chatWoot_Url:'https://chatwoot.taqe.com.br',
  chatWoot_Token: 'iCy8CWSyK41yxGMuNiGY3VQa',
  redeCidada_ids: ['67f957033cb78c1ac1c35767','5f6e59d1a2c11f001d801ca2','6822739ad68347c30594966b','6835ff01d7da1c97085afeb5','6759e6dc4df6f6aac530350f','686fcd9e0c6dbf9bc4ca2932','6835ff01d7da1c97085afeb5','6970c9371b14b6055183421e']
};
